import { useGlobalData } from 'contexts';
import React, { useState } from 'react';

export function LazyComponent({
  children,
  timeToRender = 0,
}: Props & React.HTMLProps<HTMLDivElement>) {
  const ref = React.useRef(null);
  const { isBot } = useGlobalData();
  const [hydrated, setHydrated] = useState(isBot ? true : false);

  React.useLayoutEffect(() => {
    if (isBot || !ref.current) return;

    const ob = new IntersectionObserver((entries, observer) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setHydrated(true);
          observer.disconnect();
          return;
        }
      }
    });

    ob.observe(ref.current);

    function hydrate(deadline: IdleDeadline) {
      if (deadline.timeRemaining() > timeToRender) {
        setHydrated(true);
        ob.disconnect();
      } else {
        requestIdleCallback(hydrate);
      }
    }

    if (timeToRender > 0) {
      requestIdleCallback(hydrate);
    }

    return () => ob.disconnect();
  }, [isBot, timeToRender]);

  return (
    <div ref={ref} className="lazy-component">
      {hydrated ? (
        children
      ) : (
        <div className="fake-body" style={{ width: '100%', height: 200 }} />
      )}
    </div>
  );
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  timeToRender?: number;
}
